import { assetsPath } from "../../utils";

const baseAssetUrl = assetsPath("phuket-laguna-park-2");

const img1 = `${baseAssetUrl}/images/concept/1. LP2-Exterior-Villas-007.jpg`;
const img2 = `${baseAssetUrl}/images/concept/2. LP2-Exterior-Townhomes-003.jpg`;
const img3 = `${baseAssetUrl}/images/concept/3. LP2-Exterior-Townhomes-002.jpg`;
const img4 = `${baseAssetUrl}/images/concept/4. LP2-Interior-Townhomes Living room-002.jpg`;
const img5 = `${baseAssetUrl}/images/concept/5. LP2-Interior-Townhomes Bedroom-001.jpg`;

const imageSlider = [
  { image: img1 },
  { image: img2 },
  { image: img3 },
  { image: img4 },
  { image: img5 },
];

const content = {
  en: `<p>Phuket’s most desired residential neighbourhood</p>
    <br />
    <p>Nestled amongst tropical greenery in a gated estate, the new Laguna Park 2 is located adjacent to Laguna Phuket, the 1,000-acre integrated resort complex along a three- kilometre stretch of pristine beach at Bang Tao Bay.</p>
    <br />
    <p>The contemporary-styled townhomes and villas provide spacious living areas in a secure, gated environment which will include 24-hour security, recreational and communal facilities and professional property management services by Laguna.</p>`,
  cn: `<p>普吉岛最受青睐的住宅区</p>
    <br />
    <p>新推出的乐古浪熙园二期项目坐 落在郁郁葱葱的热带草木之中， 位于普吉岛乐古浪，这个1000英 亩的综合度假胜地在邦道湾原始 古朴的海滩上绵延三公里。</p>
    <br />
    <p>现代风格的联排别墅和独栋别墅在安全的封闭式环境中提供了宽敞的居住空间，包括二十四小时安保、娱乐和公共设施以及乐古浪提供的专业物业管理服务</p>`,
  ru: `<p>Самый желанный жилой район на Пхукете</p>
    <br />
    <p>Новый охраняемый жилой комплекс Laguna Park Фаза 2 расположен среди пышной тропической зелени по соседству с удостоенным множества наград курортным комплексом Laguna Phuket, занимающим 1000 акров, простирающихся вдоль чистейшего пляжа Банг Тао.</p>
    <br />
    <p>Созданные в современном стиле таунхаусы и виллы отличаются просторными жилыми помещениями и расположением на безопасной территории под круглосуточной охраной. Доступны места для отдыха общего пользования, а также услуги по профессиональному управлению собственностью, предоставляемые комплексом Laguna.</p>`,
};

export default {
  imageSlider,
  content,
};



// WEBPACK FOOTER //
// ./src/data/PhuketLagunaPark2/concept.js